import { useQuery } from '@tanstack/react-query'
import Axios from 'axios'

import { TApiResult } from '@/libs/types/global.types'

export const GET_CLIENT_CONFIG = 'get_client_config'

export type TGetClientConfigQueryResult = {
  hideLogo?: boolean
  customLogoUrl?: string
  useOwnLoyaltyPlatform: boolean
  withdrawMethodWhitelist: { name: string; type: string }[]
  loyaltyPlatform?: {
    loyaltyPlatformIcon: string
    loyaltyPlatformName: string
    loyaltyPlatformPrefix?: string
    loyaltyPlatformSuffix?: string
  }
}

export type TGetClientConfigParams = {
  useMockServer?: boolean
  clientId: string
}

export const getClientConfig = async ({
  clientId,
}: TGetClientConfigParams): Promise<TApiResult<TGetClientConfigQueryResult>> => {
  const baseUrl = process.env.NEXT_PUBLIC_API_URL

  const path = baseUrl + `/user/partner/config`

  return await Axios.post(path, { clientId })
    .then((res) => res.data)
    .catch((err) => err)
}

export const useGetClientConfigQuery = ({
  clientId,
  queryOption = {},
}: TGetClientConfigParams & { queryOption?: any }) => {
  return useQuery<
    TGetClientConfigParams,
    Error,
    TApiResult<TGetClientConfigQueryResult>,
    [typeof GET_CLIENT_CONFIG, string]
  >({
    ...queryOption,
    queryKey: [GET_CLIENT_CONFIG, clientId],
    queryFn: () => getClientConfig({ clientId }),
    enabled: !!clientId,
  })
}
